import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EditScheduleModalComponent } from '../edit-schedule-modal/edit-schedule-modal.component';

@Component({
  selector: 'schedule-display-section',
  templateUrl: './schedule-display-section.component.html',
})
export class ScheduleDisplaySectionComponent implements OnInit, OnChanges {
  @Input() workOrder: any;
  @Output() refreshNeeded: EventEmitter<any> = new EventEmitter();

  public form: FormGroup;
  public siteFormsOptions: any[] = [];
  public isToday: boolean;
  public isSameDay: boolean;
  public hasValue: boolean;

  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.setup();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['workOrder'].previousValue || !changes['workOrder'].currentValue) return;

    if (changes['workOrder'].previousValue.scheduledStartTime !== changes['workOrder'].currentValue.scheduledStartTime
      || changes['workOrder'].previousValue.scheduledEndTime !== changes['workOrder'].currentValue.scheduledEndTime) {
        this.setup();
    }
  }

  private setup() {
    let start = this.workOrder.scheduledStartTime;
    let end = this.workOrder.scheduledEndTime;
    this.hasValue = true;

    if (!start || !end) {
      this.hasValue = false;
      return
    }

    const today = new Date();
    const startClone = new Date(start);
    const endClone = new Date(end);

    this.isToday = today.setHours(0, 0, 0, 0) === startClone.setHours(0, 0, 0, 0);
    this.isSameDay = startClone.setHours(0, 0, 0, 0) === endClone.setHours(0, 0, 0, 0);
  }

  public edit() {
    const modalOptions: NgbModalOptions = { centered: true };
    const modal = this.modalService.open(EditScheduleModalComponent, modalOptions);
    modal.componentInstance.workOrder = this.workOrder;

    modal.result.then(result => {
      if (result === 'refresh') {
        this.refreshNeeded.emit();
      }
    }).catch(() => { /* modal dismissed */ });
  }
}
